// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2iYq7","unreadBadge":"styles_unreadBadge__x2x7P","modalContent":"styles_modalContent__2pn5D","modal":"styles_modal__3qsxE"};